// Copyright (c) 2020 Deere & Company

import './index.scss';

import ATPSetup from './atpSetup';
import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';

function ATPSetupPage () {

    return (
        <AuthenticatedPage className="atp-page atp-admin-page">
            <ATPSetup />
        </AuthenticatedPage>
    );

}
ATPSetupPage.displayNAme = 'ATPSetupPage';

export default ATPSetupPage;
